import { useAuth0 } from '@auth0/auth0-react';
import { useMutation } from '@tanstack/react-query';
import axios from 'axios';
import { useCurrentUserDetails } from 'entities/user/model';

export const useCreateInvoiceByClientInvoice = () => {
  const { getCurrentOrganizationId } = useCurrentUserDetails();
  const { getAccessTokenSilently } = useAuth0();
  const mutation = useMutation({
    mutationKey: ['quickbooks-invoice-by-client-invoice'],
    mutationFn: async ({
      invoiceId,
      qbCustomerId,
      qbAccountId,
      qbTaxAmount,
    }: {
      invoiceId: string;
      qbCustomerId: string;
      qbAccountId: string;
      qbTaxAmount: string;
    }) => {
      const token = await getAccessTokenSilently();
      const resp = await axios.post(
        `${process.env.REACT_APP_SERVER_URL}/api/public/quick-books-online/invoice-by-client-invoice`,
        {
          organizationId: getCurrentOrganizationId(),
          invoiceId,
          qbCustomerId,
          qbAccountId,
          qbTaxAmount: String(qbTaxAmount),
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      return resp.data?.result;
    },
  });

  return mutation;
};
